import { useTranslation } from '@packlink/translation-provider';
import { Notification, NotificationType } from '@components/Notification/index';
import { HELP_CENTER_KEYS, useHelpCenter } from '@packlink/provider';

export const ExtraChargesNotification = (): JSX.Element => {
    const { t } = useTranslation();
    const getSupportPage = useHelpCenter();

    return (
        <Notification type={NotificationType.INFO} inline={true}>
            <p
                dangerouslySetInnerHTML={{
                    __html: t('non-gb-delivery-service.extra-charges.notification', {
                        additionalChargesHref: getSupportPage(HELP_CENTER_KEYS.additionalCharges),
                    }),
                }}
            />
        </Notification>
    );
};
